;(function (angular, _) {
  'use strict'
  angular.module('kilo.routes.dashboard')
    .controller('DashboardChangeModalController', DashboardChangeModalController)

  DashboardChangeModalController.$inject = [
    // Angular
    '$state',
    // Libs
    // Managers
    'DashboardManager',
    // Services
    // Const
    // Resolved
    'current',
    'dashboards',
    'shared'
  ]

  function DashboardChangeModalController (
    // Angular
    $state,
    // Libs
    // Managers
    DashboardManager,
    // Services
    // Const
    // Resolved
    current,
    dashboards,
    shared
  ) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
        // Public Attributes
        current: current,
        dashboards: dashboards,
        shared: shared,
        // Public Method
        newDashboard: newDashboard
      })
  
      init()
    }

    function init () {
      self.activeTab = getActiveTab()
    }

    function getActiveTab () {
      return self.shared.length === 0 ? 1 : 0
    }

    function newDashboard () {
      DashboardManager.create({ label: 'Nouveau Tableau de Bord' })
        .save()
        .then(function (saved) {
          $state.go('dashboard', { current: saved.data._id })
        })
    }
  }
})(window.angular, window._)
